import React from "react";
import lodashCloneDeep from "lodash/cloneDeep";
import { Set } from "immutable";
import { TargetGroupWithTargets } from "components/product-collection/footer/types";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { useThresholdWarningMessage } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/dimensions-tool-panel/useThresholdWarningMessage";

export const useWarningThreshold = (
    dimensionPanelState: DimensionsPanelReduxState,
    targetGroupsWithTargets: TargetGroupWithTargets[],
    selectedTargetIds: Set<string>
) => {
    // We want to only clone this once if it changes
    const clonedDimensionPanel = React.useMemo(() => {
        return lodashCloneDeep(dimensionPanelState);
    }, [dimensionPanelState]);

    const activatedTargetGroups = targetGroupsWithTargets.filter((targetGroupWithTargets) => {
        return targetGroupWithTargets.targets.some((target) => selectedTargetIds.has(target.id));
    });

    const metricsToBeActivated = activatedTargetGroups.reduce((acc, activatedTargetGroup) => {
        acc[activatedTargetGroup.metric] = true;
        return acc;
    }, {});

    // We purposely mutate this
    const modifiedDimensionPanel: DimensionsPanelReduxState = {
        ...clonedDimensionPanel,
        showDoors: true,
        metrics: {
            ...clonedDimensionPanel.metrics,
            values: clonedDimensionPanel.metrics.values.map((metric) => {
                if (metricsToBeActivated[metric.kind]) {
                    return {
                        ...metric,
                        showSubtotals: true,
                        showTotals: true,
                        showValue: true,
                    };
                }
                return metric;
            }),
        },
    };

    const warningMessage = useThresholdWarningMessage(modifiedDimensionPanel, "");

    return warningMessage;
};
